// extracted by mini-css-extract-plugin
export default {"language_switcher":"LanguageSwitcher_language_switcher__VtEGA","formControl":"LanguageSwitcher_formControl__ahSpZ"};